'use strict';
const angular = require('angular');

export class linkListComponent {
  constructor(SettingsService) {
    'ngInject';

    this.SettingsService = SettingsService;
    this.id = null;
    this.linkList = [];
  }

  $onInit() {
    this.SettingsService.getByName({name: this.settings}, setting => {
      this.id = (setting.data.id) ? setting.data.id : "linkList_" + new Date().getTime()
      this.linkList = setting.data.linkList;
    });
  }
}

export default angular.module('conduu.ap.components.linkList', [])
  .component('linkList', {
    template: require('./link-list.component.html'),
    bindings: {
      settings: '@',
      id: '@'
    },
    controller: linkListComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~ap/components/link-list/link-list.component.js